import useSWR, { SWRResponse } from 'swr';
import { AxiosError } from 'axios';
import hash from 'object-hash';
import { SerpAgent } from '../../../providers/api/dtos';
import { PaginatedResult, PaginationParams } from '../../../providers/pagination';
import { getSerpAgents, SerpAgentsProviderFilters } from '../../../providers/api/serp-agents/getSerpAgents';

export const AGENTS_SERP_RID = '/api/v1/serp/agents';

export function useSerpAgents(
  filters?: SerpAgentsProviderFilters,
  pagination: PaginationParams = { size: 20 },
): SWRResponse<PaginatedResult<SerpAgent>, Error> {
  const key = filters ? [AGENTS_SERP_RID, hash({ ...filters, ...pagination })] : null;

  const result = useSWR(key, () => getSerpAgents(filters, pagination)) as SWRResponse<PaginatedResult<SerpAgent>, AxiosError<Error>>;

  return result;
}
